import { render, staticRenderFns } from "./itemTable.vue?vue&type=template&id=e4c90edc&scoped=true&"
import script from "./itemTable.vue?vue&type=script&lang=ts&"
export * from "./itemTable.vue?vue&type=script&lang=ts&"
import style0 from "./itemTable.vue?vue&type=style&index=0&id=e4c90edc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4c90edc",
  null
  
)

export default component.exports